import React, { useState,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function ConsumerLogin() {
    const [mobilenumber, setMobilenumber] = useState('');
    const navigate = useNavigate();
    const [isInvalidMobile, setIsInvalidMobile] = useState(false);
    const ConsumerLogin = process.env.REACT_APP_FORE_BRICKBUCKET + 'customer/customer-login';
    const [message, setMessage] = useState();
    const [error, setError] = useState('');
    const [mobileStartError, setMobileStartError] = useState('');
    const [loading, setLoading] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [confirmationMessage, setConfirmationMessage] = useState('');



useEffect(() => {
    const userData = localStorage.getItem('userData');
    
    if (userData) {
        const parsedData = JSON.parse(userData);
        if (parsedData.customer_status === 3) {
            // Set sessionStorage data before navigation
            sessionStorage.setItem('userData', JSON.stringify(parsedData));
            sessionStorage.setItem('token', parsedData.token);
            sessionStorage.setItem('customerId', parsedData._id);
            sessionStorage.setItem('hubId', parsedData.hubId);
            sessionStorage.setItem('roleId', parsedData.roleId);
            
            // Navigate with complete data
            navigate('/consumer/projectDetails', { 
                state: { 
                    userData: parsedData,
                    customer_id: parsedData._id 
                } 
            });
        }
    }
    window.scrollTo(0, 0);
}, [navigate]);

   
    
   const handleOTP = async (forceLogin = false) => {
  if (mobilenumber.length !== 10) {
    setIsInvalidMobile(true);
    return;
  }

  setError('');
  setMessage('');
  setLoading(true); // ✅ start loading

  try {
    const res = await fetch(ConsumerLogin, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ mobile_number: mobilenumber, forceLogin }),
    });

    const responseData = await res.json();

    if (res.ok) {
      navigate('/consumer/otp', { state: { mobileNumber: mobilenumber } });
    } else if (res.status === 409 && responseData.requireConfirmation) {
      setConfirmationMessage(responseData.message || 'Already logged in on another device. Continue?');
      setShowConfirmation(true);
    } else if (res.status === 404) {
      sessionStorage.setItem('unregisteredMobile', mobilenumber);
      setError(responseData.message || 'User not registered. Please register.');
    } else {
      setError(responseData.message || 'Login failed. Please try again.');
    }
  } catch (err) {
    console.error('Error:', err);
    setError('An error occurred. Please try again later.');
    clearStorageAndRedirectToHome();
  } finally {
    setLoading(false); // ✅ stop loading
  }
};

  const handleDuplicateSessionConfirm = () => {
    setShowConfirmation(false);
    handleOTP(true);
  };

  const handleDuplicateSessionCancel = () => {
    setShowConfirmation(false);
  };

    
    function clearStorageAndRedirectToHome() {
      window.location.href = '/bb/user';
    }
    
     useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

   const handleChange = (e) => {
  const value = e.target.value.replace(/\D/g, '').slice(0, 10);
  setMobilenumber(value);
  setIsInvalidMobile(false);
  setError('');
  setMobileStartError('');

  // ✅ First digit validation
  if (value.length >= 1 && !['6', '7', '8', '9'].includes(value[0])) {
    setMobileStartError('Mobile number must start with 6, 7, 8, or 9');
  }
};


  const handleRegister = () => {
  // Store current mobile number if entered
  if (mobilenumber) {
    sessionStorage.setItem('unregisteredMobile', mobilenumber);
  }
  navigate('/consumer/UserDetails'); 
};



    return (
        <div className="w-full min-h-screen flex justify-center items-center bg-white">
            <div className="w-full max-w-md px-6 py-10 flex flex-col items-center justify-center">
                {/* Logo and welcome text */}
                <div className="flex flex-col items-center mb-8">
                    <img src="/BB.png" alt="Logo" className="h-20 w-20 mb-6" />
                    <h2 className="text-xl  text-[#00000] text-center">Welcome to Brickbucket</h2>
                    <p className="text-[#A8A1A1] mt-1 text-center text-md font-semibold">Build Together. Build Strong.</p>
                </div>
                
                {/* Login card - centered with fixed width */}
                <div className="bg-white rounded-md shadow-sm border border-[#D64541] overflow-hidden w-full max-w-sm mx-auto  flex flex-col justify-between">
    <div className="px-4 py-5">
        <h3 className="text-lg font-semibold text-[#00000] ml-1">Login with your Mobile Number</h3>
    </div>
    
    <div className="px-5 pb-7 flex-grow flex flex-col justify-center">
        {/* Mobile input field */}
        <div className="mb-4">
            <label htmlFor="mobile" className="block text-md font-medium text-gray-700 mb-2">
                Mobile Number
            </label>
       <div className="relative">
   
    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pr-3 pointer-events-none bg-[#F0EBEB] rounded-l-md border-l border-t border-b border-[#D64541] overflow-hidden">
    <span className="text-gray-600 font-medium">+91</span>
</div>

    <input
    id="mobile"
    type="tel"
    inputMode="numeric"
    pattern="[0-9]*"
    placeholder="Enter 10 digit mobile number"
    className={`w-full rounded-md py-3 pl-16 pr-3 border bg-white text-black  placeholder:text-sm placeholder:font-medium placeholder:text-gray-500 ${
        isInvalidMobile ? 'border-[#C20C0C] focus:ring-[#C20C0C]' : 'border-[#C20C0C] focus:ring-[#C20C0C]'
    } focus:border-[#C20C0C] focus:outline-none focus:ring-0 autofill:!bg-white autofill:!text-black autofill:shadow-[inset_0_0_0px_1000px_white]`}
    value={mobilenumber}
    onChange={handleChange}
/>


</div>


            {isInvalidMobile && (
                <p className="text-[#D64541] font-semibold text-sm mt-1">Mobile number must be 10 digits</p>
            )}
            {mobileStartError && (
  <p className="text-[#D64541] font-semibold text-sm mt-1">
    {mobileStartError}
  </p>
)}
        </div>
        
        {/* Error message display */}
        {error && (
            <div className="text-center text-sm mb-4 text-[#D64541] font-medium">{error}</div>
        )}
        
        {/* Success message display */}
        {message && (
            <div className="text-center text-sm mb-4 text-green-600 font-medium">{message}</div>
        )}
        
        {/* Send OTP button */}
        <div className="mt-1">
          <button
            className={`w-full py-3 px-4 text-lg font-semibold rounded-md text-white ${
              loading ? 'bg-gray-400 cursor-not-allowed' : 'bg-[#D64541] hover:bg-[#C20C0C]'
            }`}
            onClick={() => handleOTP()}
            disabled={loading}
          >
            {loading ? 'Sending OTP...' : 'Send OTP'}
          </button>
        </div>

                
                {/* Register link */}
                <div className="mt-4 text-center">
                    <p className="text-[#827E7E] font-semibold text-md">
                        Don't have an account? 
                        <span 
                            className="text-[#3E1EDD] font-semibold text-md cursor-pointer ml-1 hover:underline"
                            onClick={handleRegister}
                        >
                            Register
                        </span>
                    </p>
                </div>
            </div>
        </div>

        {showConfirmation && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 mx-4 max-w-sm w-full">
              <div className="text-center">
                <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 mb-4">
                  <svg className="h-6 w-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
                  </svg>
                </div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">Confirm Login</h3>
                <p className="text-sm text-gray-600 mb-4">{confirmationMessage}</p>
                <div className="flex space-x-3">
                  <button
                    onClick={handleDuplicateSessionCancel}
                    className="flex-1 py-2 px-4 bg-gray-300 hover:bg-gray-400 text-gray-800 rounded-md transition duration-300"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleDuplicateSessionConfirm}
                    className="flex-1 py-2 px-4 bg-[#D64541] hover:bg-[#C20C0C] text-white rounded-md transition duration-300"
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );

}
export default ConsumerLogin;
